import { CountryListConstants } from '../constants';

export function countryListReducer(state = {}, action) {
    switch (action.type) {
        case CountryListConstants.GETALL_COUNTRIES_REQUEST:
            return {
                loading: true
            };
        case CountryListConstants.GETALL_COUNTRIES_SUCCESS:
            return {
                items: action.countryList,
                loading:false
            };
        case CountryListConstants.GETALL_COUNTRIES_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}